import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { SD_SPNameList } from '../../Utility/StaticDatas';

const SPMasterAdminAnonymousApi = createApi({
  reducerPath: 'SPMasterAdminAnonymousApi',
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.REACT_APP_APIBaseUrl}/AnonymousDataGet/ExecuteJson/${SD_SPNameList.DB_SP_MasterAdminAnonymous}`,
  }),
  tagTypes: ['AnonymousCommonService'],
  endpoints: (builder) => ({
    getAnonymousAllCountryCodeList: builder.query({
      query: () => ({
        url: '1',
        method: 'POST',
        headers: {
          'Content-type': 'application/json',
        },
        body: {},
        providesTags: ['AnonymousCommonService'],
      }),
    }),
  }),
});

export const { useGetAnonymousAllCountryCodeListQuery } =
  SPMasterAdminAnonymousApi;
export default SPMasterAdminAnonymousApi;

